import { queryOptions } from '@tanstack/react-query';
import { graphql } from '#/lib/gql';
import { fetchGraphQL } from '#/lib/graphql';
import type { CitySummary } from '#/lib/location';

const LOCATION_SUMMARY_QUERY = graphql(`
  query LocationSummary($spaceId: String!) {
    place(spaceId: $spaceId) {
      locationSummary {
        name
        slug
        placeCount
        districts { name slug placeCount }
      }
    }
  }
`);

async function fetchLocationSummary(spaceId: string): Promise<CitySummary[]> {
  const data = await fetchGraphQL(LOCATION_SUMMARY_QUERY, { spaceId });
  return (data?.place?.locationSummary ?? []) as CitySummary[];
}

export const locationSummaryQueries = {
  cities: (spaceId: string) =>
    queryOptions({
      queryKey: ['places', 'location-summary', spaceId] as const,
      queryFn: () => fetchLocationSummary(spaceId),
      staleTime: 5 * 60 * 1000,
    }),
};
